import http from './http';

class UploadProfilePictureService {
  static upload(data: FormData, personalInfoId: string) {
    return http.post(`/personal-informations/${personalInfoId}/picture`, data);
  }
}
export default UploadProfilePictureService;
